var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGitHub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_443_14153)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_443_14153",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 6,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.85686 6.85742H41.1426V41.1431H6.85686V6.85742Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_443_14153)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0003 6.85742C33.4717 6.85742 41.1431 14.5289 41.1431 24.0003C41.1431 31.586 36.236 37.9931 29.4217 40.2646C28.5646 40.4146 28.2431 39.9003 28.2431 39.4503C28.2431 39.0431 28.2646 37.6931 28.2646 36.2574C32.5717 37.0503 33.686 35.2074 34.0288 34.2431C34.2217 33.7503 35.0574 32.2289 35.786 31.8217C36.386 31.5003 37.2431 30.7074 35.8074 30.686C34.4574 30.6646 33.4931 31.9289 33.1717 32.4431C31.6288 35.036 29.1646 34.3074 28.1788 33.8574C28.0288 32.7431 27.5788 31.9931 27.086 31.5646C30.9003 31.136 34.886 29.6574 34.886 23.1003C34.886 21.236 34.2217 19.6931 33.1289 18.4931C33.3003 18.0646 33.9003 16.3074 32.9574 13.9503C32.9574 13.9503 31.5217 13.5003 28.2431 15.7074C26.8717 15.3217 25.4146 15.1288 23.9574 15.1288C22.5003 15.1288 21.0431 15.3217 19.6717 15.7074C16.3931 13.4789 14.9574 13.9503 14.9574 13.9503C14.0146 16.3074 14.6146 18.0646 14.786 18.4931C13.6931 19.6931 13.0289 21.2146 13.0289 23.1003C13.0289 29.6789 17.036 31.136 20.8503 31.5646C20.2289 32.1003 19.6931 33.1289 19.6931 34.736C19.6931 37.0289 19.7146 38.8717 19.7146 39.4503C19.7146 39.9003 19.3931 40.436 18.536 40.2646C11.7646 37.9931 6.85742 31.5646 6.85742 24.0003C6.85742 14.5289 14.5288 6.85742 24.0003 6.85742Z",
    fill: "white",
    fillOpacity: 0.1
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_443_14153",
    x: 6.85742,
    y: 6.85742,
    width: 34.2852,
    height: 33.4395,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_443_14153"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitHub);
export default __webpack_public_path__ + "static/media/gitHub.b8972b7b4f3e1f3fbaccf862937a8a44.svg";
export { ForwardRef as ReactComponent };